/* global dataLayer, tracker */
import AMCommonGenericTopBannerES6 from '@html/generic-top-banner/script_es6';
import AMCommonSaleTopBannerES6 from '@html/sale-top-banner/script_es6';

import * as amplitude from '@amplitude/analytics-browser';
import { userAgentEnrichmentPlugin } from '@amplitude/plugin-user-agent-enrichment-browser';

let isIosDevice;
let hasPassiveEvents;
let clientY;
let cdnUrl;
let cdnVersion;
let lsStatus;
let promptDisplayed = false;
let CSRF_INPUT_OBJECT = null;
const interactions = {};
const CSRF_INPUT_ID = '#js-ao-settings-security-input';
const windowActions = [];
let pwaPrompt = null;
const GENERAL_QUESTION_ID = 96147;

export const getCdnUrl = () => {
  if (window.trConfig && window.trConfig.cdn_css_js) {
    return window.trConfig.cdn_css_js;
  }

  if (!cdnUrl) {
    cdnUrl = `${window.location.host}/`;
    if (cdnUrl.indexOf('.com') >= 0) {
      if (cdnUrl.indexOf('www.') >= 0) {
        cdnUrl = cdnUrl.replace('www.', 'cdn.');
      } else {
        cdnUrl = `cdn.${cdnUrl}`;
      }
    }

    cdnUrl = `//${cdnUrl}`;
  }

  return cdnUrl;
};
export const scriptUrl = {
  privateRequest: `${getCdnUrl()}include/pw/_common/private_request/private_request_interactions.min.js`,
  askAQuestion: `${getCdnUrl()}include/pw/_common/ask_a_question.min.js`,
  signup: `${getCdnUrl()}include/pw/_common/signup.min.js`,
  downloadBrochure: `${getCdnUrl()}include/pw/_common/download-brochure.min.js`,
  accordion: `${getCdnUrl()}include/pw/_common/accordion.min.js`,
  emailAquisitionPopup: `${getCdnUrl()}include/pw/_common/email_aquisition_popup.min.js`,
  headerNavigation: `${getCdnUrl()}include/pw/_common/header/header_navigation.min.js`,
  headerPaxSelector: `${getCdnUrl()}include/pw/_common/header/header_pax_selector.min.js`,
  cesRating: `${getCdnUrl()}include/pw/_common/ces_rating.min.js`,
  lightbox: `${getCdnUrl()}include/pw/_common/lightbox.min.js`,
  lightboxManager: `${getCdnUrl()}include/pw/_common/lightbox_manager.min.js`,
};
export const generalQuestionId = GENERAL_QUESTION_ID;
export const logged = $('html').is('.logged');
export const language = $('html').attr('lang');

// eslint-disable-next-line import/no-mutable-exports
export let parameters = {};
let isServiceWorkerSupported;
let hasActiveServiceWorker;

export const checkString = (string, pattern) => {
  switch (pattern) {
    case 'email':
      // eslint-disable-next-line no-control-regex
      return /^[a-z0-9!'#$%&*+/=?^_`{|}~-]+(?:\.[a-z0-9!'#$%&*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z]{2,}$/.test(
        String(string).toLowerCase(),
      );
    default:
      break;
  }

  return false;
};

export const ucfirst = (string) => {
  const text = `${string}`;
  const firstCharacter = text.charAt(0).toUpperCase();

  return firstCharacter + text.substr(1);
};

export const formatNumber = (args) => {
  const strippedNumber = `${args.number}`
    .replace(',', '')
    .replace(' ', '');
  const number = !isFinite(+strippedNumber) ? 0 : +strippedNumber; // eslint-disable-line
  const precision = !isFinite(+args.decimals) // eslint-disable-line
    ? 0
    : Math.abs(args.decimals); // eslint-disable-line
  const thousandSeperator = typeof args.thousandSeperator === 'undefined'
    ? ','
    : args.thousandSeperator;
  const decimalPoint = typeof args.decimalPoint === 'undefined'
    ? '.'
    : args.decimalPoint;
  let s = '';

  const toFixedFix = (n, prec) => {
    const k = 10 ** prec;

    return `${Math.round(n * k) / k}`;
  };

  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (
    precision ? toFixedFix(number, precision) : `${Math.round(number)}`
  ).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandSeperator);
  }
  if ((s[1] || '').length < precision) {
    s[1] = s[1] || '';
    s[1] += new Array(precision - s[1].length + 1).join('0');
  }

  return s.join(decimalPoint);
};

export const setCookie = (args) => {
  const {
    name, value, path, domain, secure,
  } = args;
  let { expires } = args;
  if (expires) {
    const date = new Date();
    date.setTime(date.getTime() + expires * 1000);
    expires = date.toGMTString();
  }

  document.cookie = `${name}=${escape(value)}${
    expires ? `; expires=${expires}` : ''
  }${path ? `; path=${path}` : ''}${domain ? `; domain=${domain}` : ''}${
    secure ? '; secure' : ''
  }`;
};

export const getCookie = (name) => {
  const cookie = ` ${document.cookie}`;
  const search = ` ${name}=`;
  let setStr = null;
  let offset = 0;
  let end = 0;
  if (cookie.length > 0) {
    offset = cookie.indexOf(search);
    if (offset !== -1) {
      offset += search.length;
      end = cookie.indexOf(';', offset);
      if (end === -1) {
        end = cookie.length;
      }

      setStr = unescape(cookie.substring(offset, end));
    }
  }

  return setStr;
};

export const isElementOnScreen = (element, minus, type) => {
  const $element = $(element);
  const tolerance = typeof minus !== 'undefined' ? minus : 0;
  const checkType = typeof type !== 'undefined' ? type : 'top';

  if ($element.length) {
    const $window = $(window);
    const docViewTop = $window.scrollTop();
    const docViewBottom = docViewTop + $window.height();
    const elemTop = $element.offset().top;
    const elemBottom = elemTop + $element.height() - tolerance;

    if (checkType === 'top') {
      return (
        Math.min(elemBottom, docViewBottom) >= Math.max(elemTop, docViewTop)
      );
    }

    if (checkType === 'bottom') {
      return elemBottom > docViewTop && elemBottom < docViewBottom;
    }
  }

  return false;
};

export const smoothScroll = (args) => {
  const {
    to, duration, callback, shift,
  } = args;
  const scrollTop = $(window).scrollTop();

  if (duration < 0) {
    if (callback) {
      callback();
    }
    return;
  }

  const difference = (!isNaN(parseFloat(to)) && isFinite(to) // eslint-disable-line
    ? to
    : to.offset().top + (shift || 0)) - scrollTop; // eslint-disable-line

  let perTick;
  if (duration === 0) {
    perTick = difference;
  } else {
    perTick = (difference / duration) * 10;
  }

  setTimeout(() => {
    if (!isNaN(parseInt(perTick, 10))) { // eslint-disable-line
      // eslint-disable-line
      window.scrollTo(0, scrollTop + perTick);

      smoothScroll({
        to,
        duration: duration - 10,
        callback: callback ? callback() : false,
        shift,
      });
    }
  }, 10);
};

export const stripTags = (html) => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

// eslint-disable-next-line func-names
export const debounce = function (func, wait, immediate) {
  let timeout;
  // eslint-disable-next-line func-names
  return function () {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    // eslint-disable-next-line func-names
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

// eslint-disable-next-line func-names
export const throttle = function (callback, scope, timeout = 250) {
  let last;
  let deferTimer;
  // eslint-disable-next-line func-names
  return function () {
    const context = scope || this;

    const now = +new Date();
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    if (last && now < last + timeout) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        callback.apply(context, args);
      }, timeout);
    } else {
      last = now;
      callback.apply(context, args);
    }
  };
};

export const initiateBodyScrollLock = () => {
  isIosDevice = typeof window !== 'undefined'
    && window.navigator
    && window.navigator.platform
    && /iP(ad|hone|od)/.test(window.navigator.platform);

  if (!isIosDevice) {
    return;
  }

  // Older browsers don't support event options, feature detect it.
  hasPassiveEvents = false;
  if (typeof window !== 'undefined') {
    const passiveTestOptions = {
      get passive() {
        hasPassiveEvents = true;

        return undefined;
      },
    };

    window.addEventListener('testPassive', null, passiveTestOptions);
    window.removeEventListener('testPassive', null, passiveTestOptions);
  }
};

export const isOverlayTotallyScrolled = (element) => element.scrollHeight - element.scrollTop <= element.clientHeight;

export const disableScrollOnBodyScrollLock = (event, element) => {
  clientY = event.targetTouches[0].clientY - clientY;
  if (element.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll
    event.preventDefault();

    return true;
  }

  if (
    isOverlayTotallyScrolled(element)
    && clientY < 0
  ) {
    // element is at the top of its scroll
    event.preventDefault();

    return true;
  }

  event.stopPropagation();

  return true;
};
export const enableBodyScrollLock = ($element) => {
  if (!isIosDevice) {
    return;
  }

  clientY = null; // remember Y position on touch start

  const element = $element[0];
  element.addEventListener(
    'touchstart',
    (event) => {
      if (event.targetTouches.length === 1) {
        // detect single touch
        ({ clientY } = event.targetTouches[0].clientY);
      }
    },
    hasPassiveEvents ? { passive: false } : undefined,
  );

  element.addEventListener(
    'touchmove',
    (event) => {
      if (event.targetTouches.length === 1) {
        // detect single touch
        disableScrollOnBodyScrollLock(event, element);
      }
    },
    hasPassiveEvents ? { passive: false } : undefined,
  );
};

export const disableBodyScrollLock = ($element) => {
  if (!isIosDevice) {
    return;
  }

  const element = $element[0];
  element.removeEventListener(
    'touchstart',
    hasPassiveEvents ? { passive: false } : undefined,
  );
  element.removeEventListener(
    'touchmove',
    hasPassiveEvents ? { passive: false } : undefined,
  );
};

export const switchLanguage = (href) => {
  const currentUrl = window.location.href;
  if (/[?&]/.test(currentUrl) && /[?&]/.test(href) === false) {
    const queryStrings = currentUrl.split('?').pop();
    window.location.href = `${href}?${queryStrings}`;
  } else if (/[#]/.test(currentUrl)) {
    const filters = currentUrl.split('#').pop();
    window.location.href = `${href}#${filters}`;
  } else {
    window.location.href = href;
  }
};

export const getMonthNameByIndex = (index, monthNames) => monthNames[index];

export const getMonthIndexByName = (name, monthNames) => monthNames.indexOf(name);

export const getCdnVersion = () => {
  if (window.trVersion) {
    return window.trVersion;
  }

  if (typeof cdnVersion === 'undefined') {
    const scripts = document.getElementsByTagName('script');

    for (let i = 0; i < scripts.length; i += 1) {
      if (/script\.v[0-9]+\.(min|orig)\.js/.test(scripts[i].src)) {
        const parts = scripts[i].src.split('/');
        if (parts.length > 0) {
          const filename = parts[parts.length - 1];
          const filenameParts = filename.split('.');
          if (filenameParts[1]) {
            cdnVersion = filenameParts[1].substr(1);
          }
        }
      }
    }
  }

  return cdnVersion;
};

export const initLazyLoad = () => {
  setTimeout(() => {
    $('img.lazy, .img.lazy').unveil(window.screen.height || 500);
  }, 10);
};

export const isObjectFitSupported = () => 'objectFit' in document.documentElement.style;

export const initiateFallbackBackgroundImages = () => {
  const bgImages = $('.bg-all img, .js-bg-all img:not(.no-object-fit)');
  if (!isObjectFitSupported() && bgImages.length > 0) {
    bgImages.each((index, element) => {
      const $element = $(element);
      const src = $element.attr('src');
      const dataSrc = $element.data('src');
      const $bgBlock = $element.parent();

      $bgBlock
        .toggleClass('img lazy', !!$element.hasClass('lazy'))
        .css('background-image', `url("${src}")`)
        .data('src', dataSrc);

      $element.remove();
    });
  }
};

export const loadAsyncCss = (href, callback, options = {}) => {
  if (!href) return;
  const version = `.v${getCdnVersion()}`;
  const style = document.createElement('link');
  style.type = 'text/css';
  style.rel = options.rel || 'stylesheet';

  if (options.as) {
    style.as = options.as;
  }

  style.href = href.indexOf('pw') < 0 || href.indexOf(version) >= 0
    ? href
    : href.replace('.css', `${version}.css`);

  if (callback) {
    style.onload = () => {
      callback();
    };
  }

  $('html').append(style);
};

export const loadJs = (href, callback, fromLibrary) => {
  const script = document.createElement('script');
  const src = fromLibrary || href.indexOf('pw') < 0
    ? href
    : href.replace('.min.js', `.v${getCdnVersion()}.min.js`);

  script.async = 'async';
  script.src = src;
  script.nonce = window.nonce;

  if (href.indexOf('.tourradar.com') >= 0) {
    script.crossOrigin = 'anonymous';
  }

  document.body.appendChild(script);

  script.onload = () => {
    if (callback) {
      callback();
    }
  };
};

export const sendRequest = (url, data, success, args, failure) => {
  let params = args;
  if (typeof args === 'undefined') {
    params = {};
  }

  // add language to the request URL
  let requestUrl = url;
  const isDomainUrl = typeof window.trConfig.domainUrl !== 'undefined'
    && window.trConfig.domainUrl !== '';
  if (
    isDomainUrl
    && url.indexOf('/') === 0 // hoping requests are always done with relative URL
  ) {
    requestUrl = `/${window.trConfig.domainUrl}${url}`;
  }

  const headers = {
    'X-Language': isDomainUrl ? window.trConfig.domainUrl : 'en',
  };

  if (params.headerContentType !== false) {
    headers['Content-Type'] = params.headerContentType ? params.headerContentType : 'application/x-www-form-urlencoded';
  }

  $.ajax({
    url: requestUrl,
    data,
    dataType: params.dataType ? params.dataType : 'json',
    type: params.type ? params.type : 'POST',
    crossDomain: params.crossDomain || false,
    processData: params.processData ?? true,
    contentType: params.headerContentType ? params.headerContentType : 'application/x-www-form-urlencoded',
    headers,
    success: (successData) => {
      if (success) {
        success(successData);
      }
    },
    error: (error) => {
      if (failure) {
        failure(error);
      }
    },
  });
};

export const showSnackbar = {
  jsFile: `${getCdnUrl()}include/pw/scout/components/snackbar/scout-snackbar.min.js`,
  loadFile: (snackbarType, args) => {
    import(/* webpackChunkName: "snackbar" */'@scout/components/snackbar/snackbar_es6').then((module) => {
      const SnackbarES6 = module.default;
      const snackbar = new SnackbarES6();
      const { load, ...snackbarTypes } = snackbar;
      load(() => {
        snackbarTypes[snackbarType](...args);
        Object.assign(showSnackbar, { ...snackbarTypes });
      }, args[1]);
    });
  },
  success: (...args) => showSnackbar.loadFile('success', args),
};

export const sendTrackerEvent = (category, action, label, params) => {
  if (typeof tracker !== 'undefined' && tracker) {
    tracker('addEvent', category, action, label, params);
  }
};

export const abTests = {
  amplitude: undefined,
  assignments: {},
  queue: {
    afterInitialization: [],
  },

  exposure(event) {
    if (!this.amplitude) {
      this.queue.afterInitialization.push(() => this.exposure(event));
      return;
    }

    if (!this.assignments[event]) {
      return;
    }

    this.amplitude.track('$exposure', {
      flag_key: event,
      variant: this.assignments[event],
    });
  },

  flush() {
    this.queue.afterInitialization.forEach((queueHandler) => queueHandler());
    this.queue.afterInitialization = [];
  },

  async syncTokens() {
    const userId = this.amplitude.getUserId();
    const deviceId = this.amplitude.getDeviceId();
    const sessionId = this.amplitude.getSessionId();

    const syncData = { userId, deviceId, sessionId };

    if (!localStorage.getItem('amplitude-first-visit')) {
      localStorage.setItem(
        'amplitude-first-visit',
        JSON.stringify({
          amp_user_id: userId,
          amp_device_id: deviceId,
          original_uri: window.location.search,
        }),
      );
    }

    const alreadySynced = (endpoint) => {
      try {
        const value = JSON.parse(localStorage.getItem(`amplitude-ab-tests-tokens-synced_${endpoint}`));

        return value.userId === syncData.userId
          && value.deviceId === syncData.deviceId
          && value.sessionId === syncData.sessionId;
      } catch {
        return false;
      }
    };

    const markSynced = (endpoint) => {
      localStorage.setItem(`amplitude-ab-tests-tokens-synced_${endpoint}`, JSON.stringify(syncData));
    };

    const callEndpoint = async (endpoint) => {
      if (alreadySynced(endpoint)) {
        return;
      }

      await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Amplitude-User-Id': this.amplitude.getUserId(),
          'X-Amplitude-Device-Id': this.amplitude.getDeviceId(),
          'X-Amplitude-Session-Id': this.amplitude.getSessionId(),
        },
      });

      markSynced(endpoint);
    };

    await Promise.all(Object.values(window.trConfig.amplitude.domains).map(callEndpoint));
  },
};

export const sendAmplitudeEvent = (params) => {
  if (typeof dataLayer !== 'undefined') {
    const fields = {
      event: 'gaEvent',
      eventLabel: '',
      eventValue: params && params.eventValue ? params.eventValue : '',
      nonInteraction: false,
    };

    if (params) {
      Object.keys(params).forEach((key) => {
        const parameter = params[key];

        if (parameter === 'value') fields.eventValue = params[key];
        else fields[key] = params[key];
      });
    }

    dataLayer.push({
      ...fields,
      ampEventName: !fields.ampEventName ? undefined : fields.ampEventName,
    });
  }

  sendTrackerEvent(null, null, null, params);
};

export const sendGoogleEvent = (category, action, label, params) => {
  if (typeof dataLayer !== 'undefined') {
    const fields = {
      event: 'gaEvent',
      eventCategory: category,
      eventAction: action,
      eventLabel: label || '',
      eventValue: params && params.eventValue ? params.eventValue : '',
      nonInteraction: false,
    };

    if (params) {
      Object.keys(params).forEach((key) => {
        const parameter = params[key];

        if (parameter === 'value') {
          fields.eventValue = params[key];
        } else {
          fields[key] = params[key];
        }
      });
    }

    dataLayer.push({
      ...fields,
      ampEventName: !fields.ampEventName ? undefined : fields.ampEventName,
    });
  }

  sendTrackerEvent(category, action, label, params);
};

export const setIntersectionObserver = ({
  selector,
  callback,
  exitCallback = null,
  rootMargin = '0px',
  threshold = 0,
  unobserveOnEntry = false,
  unobserveOnExit = false,
}) => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const targetElement = entry.target;
      if (entry.isIntersecting) {
        if (callback && typeof callback === 'function') {
          callback(targetElement);
          if (unobserveOnEntry) {
            observer.unobserve(targetElement);
          }
        }
      } else if (exitCallback && typeof exitCallback === 'function') {
        exitCallback(targetElement);
        if (unobserveOnExit) {
          observer.unobserve(targetElement);
        }
      }
    });
  }, {
    root: null,
    rootMargin,
    threshold,
  });

  const targetElements = document.querySelectorAll(selector);
  targetElements.forEach((element) => {
    observer.observe(element);
  });
};

export const generateInViewportEvent = (eventData) => {
  let hasEventRun = false;
  /**
   * Handles intersection changes and triggers the Google Analytics event if the element is in view.
   *
   * @param {IntersectionObserverEntry[]} entries - The entries being observed.
   */
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !hasEventRun) {
        sendGoogleEvent(
          eventData.category,
          eventData.action,
          eventData.label,
          eventData.params,
        );
        hasEventRun = true;
      }
    });
  };
  const percentageOfElementInViewport = 0.5;
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: percentageOfElementInViewport,
  };
  const observer = new IntersectionObserver(handleIntersection, options);
  return observer;
};

export const sendDataLayerEvent = (fields) => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(fields);
  }
};

export const sendHotjarEvent = (label) => {
  if (typeof hj !== 'function') {
    // eslint-disable-next-line
    console.warn("Attempting to fire Hotjar event. Hotjar not defined.");
    return;
  }

  if (!label) {
    // eslint-disable-next-line
    console.warn("Attempting to fire Hotjar event. Missing label parameter.");
    return;
  }

  /* eslint-disable-next-line */
  hj("event", label);
};

export const getBreakpointMinWidth = (breakpoint) => {
  const breakpoints = {
    s1: 320,
    s2: 568,
    m1: 768,
    m2: 1024,
    l1: 1280,
    l2: 1440,
  };

  return breakpoints[breakpoint];
};

export const getDeviceType = () => {
  const { userAgent } = navigator;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return 'tablet';
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      userAgent,
    )
  ) {
    return 'mobile';
  }
  return 'desktop';
};

const libUse = {
  popup: {
    initiated: false,
    version: '1-1-0',
    css: 'include/js/magnific-popup/magnific-popup',
    js: 'include/js/magnific-popup/magnific-popup',
  },
  calendar: {
    initiated: false,
    version: '1-8-2',
    css: 'include/js/pikaday/css/pikaday',
    js: 'include/js/pikaday/pikaday',
  },
  customCalendar: {
    initiated: false,
    version: '1-0-0',
    css: 'include/js/pikaday/css/pikaday-custom',
    js: 'include/js/pikaday/pikaday-custom',
  },
  dayjs: {
    initiated: false,
    version: '1-11-10',
    js: 'include/npm/node_modules/dayjs/dayjs',
  },
  dayjs_plugin_updateLocale: {
    initiated: false,
    isPlugin: true,
    version: '1-0-0',
    js: 'include/npm/node_modules/dayjs/plugin/updateLocale',
  },
  dayjs_plugin_utc: {
    initiated: false,
    isPlugin: true,
    version: '1-0-0',
    js: 'include/npm/node_modules/dayjs/plugin/utc',
  },
  selector: {
    initiated: false,
    version: '2-0-1',
    css: 'include/js/selectivity/selectivity-full',
    js: 'include/js/selectivity/selectivity-full',
  },
  animation: {
    initiated: false,
    version: '1-0-0',
    css: false,
    js: 'include/js/zepto-anim',
  },
  mobile: {
    initiated: false,
    version: '1-0-2',
    css: false,
    js: 'include/js/zepto-mobile',
  },
  touch: {
    initiated: false,
    version: '1-0-2',
    css: false,
    js: 'include/js/zepto-touch',
  },
  tooltip: {
    initiated: false,
    version: '1-1-2',
    css: 'include/js/ttip/ttip',
    js: 'include/js/ttip/ttip',
  },
  dragdrop: {
    initiated: false,
    version: '1-0-0',
    css: false,
    js: 'include/js/zepto.dragswap',
  },
  autocomplete: {
    initiated: false,
    version: '1-0-7',
    css: 'include/js/tiny-autocomplete/tiny-autocomplete',
    js: 'include/js/tiny-autocomplete/tiny-autocomplete',
  },
  dynamicmap: {
    initiated: false,
    version: '1-0-0',
    css: 'include/pw/dynamicmap/leaflet',
    js: 'include/pw/dynamicmap/script',
  },
  dynamicmap_b: {
    initiated: false,
    version: '1-0-0',
    css: 'include/pw/dynamicmap/leaflet',
    js: 'include/pw/dynamicmap_b/script',
  },
};

export const libSetLoaded = (libList) => {
  if (libList instanceof Array) {
    libList.forEach((libName) => {
      libUse[libName].initiated = true;
    });
  }
};

export const libCallbackFunctions = (library, callbackJS) => {
  if (library === 'autocomplete') {
    const autocompleteInterval = setInterval(() => {
      if (typeof $.tinyAutocomplete === 'function') {
        clearInterval(autocompleteInterval);
        callbackJS();
      }
    }, 10);
  } else if (library === 'popup') {
    const popupInterval = setInterval(() => {
      if (typeof $.magnificPopup === 'object') {
        clearInterval(popupInterval);
        callbackJS();
      }
    }, 10);
  } else if (library === 'dynamicmap_b') {
    const mapInterval = setInterval(() => {
      if (typeof DynamicMap !== 'function') {
        return;
      }

      clearInterval(mapInterval);
      callbackJS();
    }, 10);
  } else {
    callbackJS();
  }
};

export const libInit = (library, callbackJS, callbackCSS) => {
  const version = window.trVersion || Math.random();

  if (!libUse[library].initiated) {
    libUse[library].initiated = true;

    if (libUse[library].css) {
      loadAsyncCss(
        `${getCdnUrl() + libUse[library].css}.v${
          libUse[library].version
        }.min.css?v=${version}`,
        () => {
          if (callbackCSS) {
            callbackCSS();
          }
        },
      );
    }

    loadJs(
      `${getCdnUrl() + libUse[library].js}${libUse[library].isPlugin ? '' : `.v${
        libUse[library].version
      }.min`}.js?v=${version}`,
      () => {
        if (callbackJS) {
          libCallbackFunctions(library, callbackJS);
        }
      },
      true,
    );
  } else {
    if (callbackCSS) {
      setTimeout(() => {
        callbackCSS();
      }, 300);
    }

    if (callbackJS) {
      setTimeout(() => {
        libCallbackFunctions(library, callbackJS);
      }, 300);
    }
  }
};

export const handleMagnificPopupHistory = {
  baseLink: '',
  isMobile: $(window).width() <= 767,
  backButtonMobileSelector: '.js-ao-common-super-popup__header-back',
  doneButtonWishlistSelector: '.wishlist_popup .but',
  mfpCloseSelector: '.mfp-close',
  askQuestionCloseSelector: '#ask_popup_success .but.w-blue',
  mapCtaTdp: '.js-ao-common-map-popup__content-info-details-cta--mfp-history',

  closePopupOnBack: () => {
    if ($.magnificPopup.instance) {
      $.magnificPopup.close();
      $('body').off(
        'click',
        handleMagnificPopupHistory.onOutsideContentClick,
      );
      $('body').off(
        'click',
        handleMagnificPopupHistory.onBackButtonClick,
      );
      window.removeEventListener(
        'popstate',
        handleMagnificPopupHistory.closePopupOnBack,
      );
    }
  },

  onOutsideContentClick: (event) => {
    if (
      $(event.target).hasClass('mfp-container')
      || $(event.target).hasClass('mfp-content')
    ) {
      window.history.back();
      $('body').off(
        'click',
        handleMagnificPopupHistory.onOutsideContentClick,
      );
    }
  },

  onBackButtonClick: () => {
    window.history.back();
    $('body').off('click', handleMagnificPopupHistory.onBackButtonClick);
  },

  openPopup: () => {
    const {
      closePopupOnBack,
      onBackButtonClick,
      isMobile,
      backButtonMobileSelector,
      doneButtonWishlistSelector,
      mfpCloseSelector,
      askQuestionCloseSelector,
      mapCtaTdp,
    } = handleMagnificPopupHistory;

    const allCloseButtonSelectors = `${backButtonMobileSelector}, ${doneButtonWishlistSelector}, ${mfpCloseSelector}, ${askQuestionCloseSelector}, ${mapCtaTdp}`;

    if (isMobile) {
      window.history.pushState(
        { url: window.location.href },
        null,
        '?popupOpen',
      );
      window.addEventListener('popstate', closePopupOnBack);
      $('body').on('click', allCloseButtonSelectors, onBackButtonClick);
    }
  },

  closePopup: () => {
    const { onOutsideContentClick, isMobile } = handleMagnificPopupHistory;

    if (isMobile) {
      window.history.replaceState({}, '', window.location.href);
      $('body').on(
        'click',
        '.mfp-container, .mfp-content',
        onOutsideContentClick,
      );
    }
  },
};

let signupInitiated = false;
export const signupVersion = '2021-04-08-001';

export const signupGetJsUrl = () => `${getCdnUrl()}include/pw/_common/signup.min.js?v=${
  signupVersion
}`;
export const signupShow = (type, callback, linkType) => {
  if (!signupInitiated) {
    signupInitiated = true;

    sendRequest('/api/common/component/signup', {}, (data) => {
      $('main').append(data.component);

      import(/* webpackChunkName: "signup" */'@html/_common/signup').then((module) => {
        const Signup = module.default;
        libInit('popup', () => {
          $('.signup_link, .login_link').magnificPopup({
            closeOnBgClick: true,
            callbacks: {
              open: () => {
                handleMagnificPopupHistory.openPopup();
              },
              close: () => {
                handleMagnificPopupHistory.closePopup();
              },
            },
          });

          $('.email_add_popup_link').magnificPopup({
            closeOnBgClick: false,
            closeOnContentClick: false,
            showCloseBtn: false,
            enableEscapeKey: false,
          });

          $(`.${type}_link`).click();

          const sign = new Signup();
          sign.initiate(callback, linkType);
        });
      });
    });
  } else {
    $(`.${type}_link`).click();
  }
};

export const byUserInteraction = (name, callback) => {
  if (!interactions[name]) {
    interactions[name] = {};

    if (callback) {
      interactions[name].callback = callback;
    }
  }
};

export const getLastSearch = () => {
  const paxSearchValueFromCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_search_value='));
  const paxSearchUrlFromCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_search_url='));
  const paxSearchValueFromCookieDecoded = paxSearchValueFromCookie ? paxSearchValueFromCookie.split('=')[1] : null;
  const paxSearchUrlFromCookieDecoded = paxSearchUrlFromCookie ? paxSearchUrlFromCookie.split('=')[1] : null;
  let paxSearchValue = paxSearchValueFromCookieDecoded;
  let paxSearchUrl = paxSearchUrlFromCookieDecoded;

  const pageType = $('main').data('page-type');
  if (pageType === 'SERP' || window.location.pathname.includes('/o/')) {
    if ($('main').data('where')) {
      paxSearchValue = $('main').data('where');
      paxSearchUrl = window.location.pathname;
    } else if ($('main').data('destination')) {
      paxSearchValue = $('main').data('destination');
      paxSearchUrl = window.location.pathname;
    } else {
      // Find the first breadcrumb that is not "/" and get its text and href
      const $breadcrumbLinks = $('.js-ao-common-breadcrumbs-list__breadcrumb-link');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < $breadcrumbLinks.length; i++) {
        const $link = $breadcrumbLinks.eq(i);
        const href = $link.attr('href');
        if (href && href !== '/') {
          paxSearchValue = $link.text().trim();
          paxSearchUrl = window.location.pathname;
          break;
        }
      }
    }
  }

  if (paxSearchValue && paxSearchUrl
    && paxSearchValue !== paxSearchValueFromCookieDecoded && paxSearchUrl !== paxSearchUrlFromCookieDecoded) {
    document.cookie = `pax_search_value=${paxSearchValue}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
    document.cookie = `pax_search_url=${paxSearchUrl}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
  }

  return { paxSearchValue, paxSearchUrl };
};

export const deletePaxMonthYear = () => {
  const SELECTOR_PAX_MONTH_TEXT = '.js-ao-pax-selector-month';
  const SELECTOR_PAX_MONTH = '.js-ao-pax-month';
  const SELECTOR_PAX_MONTH_MENU_MONTH_ITEM = '.js-ao-pax-month-menu__months-grid-month';

  document.cookie = 'pax_month_year=; path=/';

  const $headerWhenElement = $('.js-ao-header-pax-selector__main-input-when');
  $headerWhenElement.text($headerWhenElement.data('placeholder'));
  $headerWhenElement.removeClass('ao-header-pax-selector__main-input-when--active');

  $(SELECTOR_PAX_MONTH_TEXT).text($(SELECTOR_PAX_MONTH_TEXT).data('placeholder'));
  $(SELECTOR_PAX_MONTH).removeAttr('data-pax-month');
  $(SELECTOR_PAX_MONTH).removeAttr('data-pax-year');

  $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function resetPaxMonthMenuMonthItem() {
    const $monthElement = $(this);
    $monthElement.removeClass('ao-pax-month-menu__months-grid-month--selected');
  });
};

export const deletePaxTravelers = () => {
  const SELECTOR_PAX_ADULT = '.js-ao-pax-selector-adult';
  const SELECTOR_PAX_ADULTS = '.js-ao-pax-selector-adults';
  const SELECTOR_PAX_ADULTS_NUMBER = '.js-ao-pax-selector-adults-number';
  const SELECTOR_PAX_CHILDREN = '.js-ao-pax-selector-children';
  const SELECTOR_PAX_TRAVELERS = '.js-ao-pax-travelers';
  const SELECTOR_PAX_ADULTS_ADD = '.js-ao-pax-travelers-menu__controls-adults-add';
  const SELECTOR_PAX_ADULTS_SUBTRACT = '.js-ao-pax-travelers-menu__controls-adults-subtract';
  const SELECTOR_PAX_CHILDREN_NUMBER = '.js-ao-pax-travelers-menu__children-number';
  const SELECTOR_PAX_CHILDREN_ADD = '.js-ao-pax-travelers-menu__controls-children-add';
  const SELECTOR_PAX_CHILDREN_SUBTRACT = '.js-ao-pax-travelers-menu__controls-children-subtract';

  document.cookie = 'pax_number_of_adults=; path=/';
  document.cookie = 'pax_number_of_children=; path=/';

  $('.js-ao-header-pax-selector__main-input-who-number').text('2');

  $(SELECTOR_PAX_ADULTS_NUMBER).text(2);
  $(SELECTOR_PAX_ADULT).addClass('hid');
  $(SELECTOR_PAX_ADULTS).removeClass('hid');
  $(SELECTOR_PAX_CHILDREN).addClass('hid');

  $(SELECTOR_PAX_TRAVELERS).removeAttr('data-pax-adults');
  $(SELECTOR_PAX_TRAVELERS).removeAttr('data-pax-children');

  $(SELECTOR_PAX_ADULTS_NUMBER).empty().text('2');
  $(SELECTOR_PAX_ADULTS_SUBTRACT).prop('disabled', false);
  $(SELECTOR_PAX_ADULTS_ADD).prop('disabled', false);

  $(SELECTOR_PAX_CHILDREN_NUMBER).empty().text('0');
  $(SELECTOR_PAX_CHILDREN_SUBTRACT).prop('disabled', true);
  $(SELECTOR_PAX_CHILDREN_ADD).prop('disabled', false);
};

export const byWindowAction = (actions, callback) => {
  if ($.inArray('load', actions) !== -1) {
    callback();
  }

  const index = actions.indexOf('load');

  if (index > -1) {
    actions.splice(index, 1);
  }

  windowActions.push({
    events: actions,
    callback,
  });
};

export const initUserInteraction = () => {
  byWindowAction(
    ['scroll', 'keydown', 'keyup', 'mousemove', 'touchend', 'touchmove', 'mousedown'],
    () => {
      $.each(interactions, (name, action) => {
        if (
          typeof action.callback !== 'function'
          || interactions[name].initiated
        ) {
          return;
        }

        interactions[name].initiated = true;
        window.requestAnimationFrame(() => {
          action.callback();
        });
      });
    },
  );
};

export const deleteInteraction = (interactionName) => {
  delete interactions[interactionName];
};

export const initWindowAction = () => {
  $(window).on(
    'scroll click keydown keyup mousemove touchend load resize lookup popstate mousedown',
    (event) => {
      $.each(windowActions, (index, action) => {
        if ($.inArray(event.type, action.events) < 0) {
          return;
        }

        action.callback(event);
      });
    },
  );
};

export const initParameters = () => {
  const mainDom = document.getElementsByTagName('main')[0];
  const params = mainDom.getAttribute('data-parameters');

  mainDom.removeAttribute('data-parameters');

  if (params) {
    parameters = JSON.parse(params) || {};
  } else {
    parameters = {};
  }
};

export const removeQueryStringParam = (key) => {
  const regEx = new RegExp(`([?&])${key}=([^&;]+)?[&;]?`);

  if (!window.location.search.match(regEx)) {
    return false;
  }

  const baseUrl = [
    window.location.protocol,
    '//',
    window.location.host,
    window.location.pathname,
  ].join('');
  const urlQueryString = document.location.search;
  let params = '';

  const oldValue = window.location.search.match(regEx)[2];

  if (urlQueryString) {
    params = urlQueryString.replace(regEx, '$1');
    params = params.replace(/[&;]$/, '');
  }

  params = params === '?' ? '' : params;
  window.history.replaceState(
    {},
    '',
    baseUrl + params + window.location.hash,
  );

  return oldValue;
};

export const cleanURL = () => {
  removeQueryStringParam('ehash');
  removeQueryStringParam('email');
};

export const lsIsAvailable = () => {
  if (typeof lsStatus !== 'undefined') {
    return lsStatus;
  }

  const test = 'testLocalStorage';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    lsStatus = true;
  } catch (e) {
    lsStatus = false;
  }

  return lsStatus;
};

export const csrfInit = () => {
  CSRF_INPUT_OBJECT = $(CSRF_INPUT_ID);
};

export const csrfSetHash = (hash) => {
  if (CSRF_INPUT_OBJECT.length) {
    CSRF_INPUT_OBJECT.val(hash);
  }
};
export const csrfGetTokenName = () => (CSRF_INPUT_OBJECT.length ? CSRF_INPUT_OBJECT.attr('name') : '');
export const csrfGetHash = () => (CSRF_INPUT_OBJECT.length ? CSRF_INPUT_OBJECT.val() : '');

export const pwaServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      if (navigator.serviceWorker.controller) {
        // eslint-disable-next-line
        console.log(
          '[PWA Builder] active service worker found, no need to register',
        ); // eslint-disable-line
      } else {
        // not possible to serve service worker from cdn (https://github.com/w3c/ServiceWorker/issues/940)
        const serviceWorkerUrl = `${
          window.location.origin
        }/include/pw/service_worker/script.min.js?v=${getCdnVersion()}`;
        byUserInteraction('load-service-worker', () => {
          navigator.serviceWorker
            .register(serviceWorkerUrl, {
              scope: '/',
            })
            .then((registration) => {
              // eslint-disable-next-line
              console.log(
                `Service worker has been registered for scope: ${registration.scope}`,
              ); // eslint-disable-line
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(`Service worker registration failed: ${error}`); // eslint-disable-line
            });
        });
      }
    });
  }
};

export const pwaEvents = () => {
  window.addEventListener('beforeinstallprompt', (event) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    event.preventDefault();
    // Stash the event so it can be triggered later.
    pwaPrompt = event;

    // byUserInteraction is not considered a user gesture
    // => user needs to activly click an element for triggering the popup
    // this.byUserInteraction('pwa-prompt', this.pwa.prompt);
  });

  window.addEventListener('appinstalled', () => {
    sendGoogleEvent('PWA', 'App', 'Installed');
  });
};
export const pwaInitiate = () => {
  pwaServiceWorker();

  if (
    window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true
  ) {
    sendGoogleEvent('PWA', 'App', 'Open');
  } else {
    pwaEvents();
  }
};

export const pwaPromptFunc = () => {
  if (!promptDisplayed) {
    const path = window.location.pathname;
    if (path !== '/registration' && path !== '/login') {
      pwaPrompt.prompt();

      sendGoogleEvent('PWA', 'Prompt', 'Show');

      pwaPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          sendGoogleEvent('PWA', 'Prompt', 'Accept');
        } else {
          sendGoogleEvent('PWA', 'Prompt', 'Dismissed');
        }

        pwaPrompt = null;
        promptDisplayed = true;
      });
    }
  }
};

export const getServiceWorkerSupport = () => {
  if (typeof isServiceWorkerSupported === 'undefined') {
    isServiceWorkerSupported = 'fetch' in window && 'serviceWorker' in navigator;
  }

  return isServiceWorkerSupported;
};

export const getActiveServiceWorkerFlag = () => {
  if (getServiceWorkerSupport()) {
    if (typeof hasActiveServiceWorker === 'undefined') {
      return new Promise((resolve) => {
        navigator.serviceWorker.ready.then(() => {
          hasActiveServiceWorker = true;

          resolve(hasActiveServiceWorker);
        });
      });
    }

    return new Promise((resolve) => {
      resolve(hasActiveServiceWorker);
    });
  }
  if (typeof hasActiveServiceWorker === 'undefined') {
    hasActiveServiceWorker = false;
  }

  return new Promise((resolve) => {
    resolve(hasActiveServiceWorker);
  });
};

export const prefetchImageFromSource = (src) => {
  if (src) {
    const img = new Image();
    img.src = src;
  }
};

export const logBrokenImages = () => {
  $('img').on('error', (e) => {
    const info = {
      url: document.location.href,
      languge: navigator.language,
      language: navigator.language,
      useragent: navigator.userAgent,
      platform: navigator.platform,
      oscpu: navigator.oscpu,
      referrer: document.referrer,
      'error[message]': 'Image loading error',
      'error[filename]': e.target.src,
      'error[stack]': e.target.className,
      type: 'image',
    };
    // @todo: add disable or enable flag for management of these requests
    sendRequest('/api/utils/jserror', info);
  });
};

export const getDomainUrl = () => (typeof window.trConfig.domainUrl !== 'undefined'
  ? window.trConfig.domainUrl
  : '');

export const initializeGenericTopBanner = () => {
  const $genericTopBanner = $('.js-am-common-generic-top-banner');
  if ($genericTopBanner.length) {
    const genericTopBanner = new AMCommonGenericTopBannerES6(
      $genericTopBanner,
    );
    genericTopBanner.initiate();
  }
};

export const initializeLazyLoadedBackgroundImagesObserver = () => {
  const lazyBackgrounds = [].slice.call(document.querySelectorAll('.ao-lazy-background'));

  if ('IntersectionObserver' in window) {
    const lazyBackgroundObserver = new IntersectionObserver(((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ao-lazy-background--visible');
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    }));

    lazyBackgrounds.forEach((lazyBackground) => {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
};

export const initializeSaleTopBanner = () => {
  const saleTopBannerSelector = '.js-am-common-sale-top-banner';
  const $saleTopBanner = $(saleTopBannerSelector);

  if (!$saleTopBanner.length) {
    return;
  }

  const saleTopBanner = new AMCommonSaleTopBannerES6(
    '.js-am-common-sale-top-banner',
  );
  saleTopBanner.initiate();
};

export const isStage = () => window.location.host.indexOf('stage') >= 0;

export const initializeAmplitudeSync = () => {
  if (!window.amplitude_events_to_track && !window.amplitude_assignments) {
    return;
  }

  const syncEvents = () => {
    const onAmplitudeLoads = (callback) => {
      // eslint-disable-next-line no-underscore-dangle
      if (!window.amplitudeGTM || !window.amplitudeGTM._iq || !window.amplitudeGTM._iq['tr-us']) {
        return setTimeout(() => onAmplitudeLoads(callback), 100);
      }
      return loadJs('https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.22.3-min.js.gz', callback);
    };

    const onAmplitudePropertiesRead = (sessionReplay = {}, callback) => {
      if (Object.keys(sessionReplay.config || {}).length === 0) {
        return setTimeout(() => onAmplitudePropertiesRead(sessionReplay, callback), 100);
      }

      return callback();
    };

    byUserInteraction('amplitude', () => onAmplitudeLoads(async () => {
      const eventsToTrack = window.amplitude_events_to_track || [];
      const assignments = window.amplitude_assignments || [];

      // eslint-disable-next-line no-underscore-dangle
      abTests.amplitude = window.tourRadarAmplitude || window.amplitudeGTM._iq['tr-us'];
      abTests.amplitudeSessionReplay = window.sessionReplay.plugin({ sampleRate: 0.2 });
      abTests.assignments = assignments;

      await abTests.amplitude.add(abTests.amplitudeSessionReplay).promise;

      window.abTests = abTests;

      onAmplitudePropertiesRead(abTests.amplitudeSessionReplay, () => {
        eventsToTrack.forEach((event) => abTests.amplitude.track(event));
        abTests.flush();
        abTests.syncTokens();
      });
    }));
  };

  syncEvents();
};

export const amplitudeUtils = () => {
  let pagePath;
  let dataLayerProperties;
  let pageType;

  const amplitudeInitialization = () => {
    const { amplitudeCustomerId, amplitudeApiKey } = dataLayerProperties;
    pagePath = window.location.pathname + window.location.search;

    const configOptions = {
      instanceName: 'tr-us',
      userId: amplitudeCustomerId === '' ? undefined : amplitudeCustomerId,
      autocapture: false,
    };

    // https://github.com/amplitude/Amplitude-TypeScript/tree/v1.x/packages/plugin-user-agent-enrichment-browser
    // tracks 'os_name', 'os_version', 'device_manufacturer', 'device_model'
    const uaPlugin = userAgentEnrichmentPlugin();
    amplitude.add(uaPlugin);

    amplitude.init(amplitudeApiKey, configOptions);

    window.tourRadarAmplitude = amplitude;
  };

  const getParamPageDomain = () => {
    const languageMap = {
      '/de/': 'DE',
      '/nl/': 'NL',
      '/es/': 'ES',
      '/fr/': 'FR',
    };

    const code = Object.entries(languageMap).find(([prefix]) => pagePath.startsWith(prefix))?.[1];

    return code || 'EN';
  };

  const getParamPageTypeDetailed = () => {
    const patterns = {
      '.*\\/sc\\/.*': 'List Landing Page SC',
      '.*\\/d\\/.*': 'List Landing Page D',
      '.*\\/a\\/.*': 'List Landing Page A',
      '.*\\/b\\/.*': 'List Landing Page B',
      '.*\\/c\\/.*': 'List Landing Page C',
      '.*\\/f\\/.*': 'List Landing Page F',
      '.*\\/fa\\/.*': 'List Landing Page FA',
      '.*\\/fj\\/.*': 'List Landing Page FJ',
      '.*\\/g\\/.*': 'List Landing Page G',
      '.*\\/i\\/.*': 'List Landing Page I',
      '.*\\/il\\/.*': 'List Landing Page IL',
      '.*\\/j\\/.*': 'List Landing Page J',
      '.*\\/l\\/.*': 'List Landing Page L',
      '.*\\/m\\/.*': 'List Landing Page M',
      '.*\\/n\\/.*': 'List Landing Page N',
      '.*\\/p\\/.*': 'List Landing Page P',
      '.*\\/pa\\/.*': 'List Landing Page PA',
      '.*\\/r\\/.*': 'List Landing Page R',
      '.*\\/s\\/.*': 'List Landing Page S',
      '.*\\/u\\/.*': 'List Landing Page U',
      '.*\\/v\\/.*': 'List Landing Page V',
      '.*\\/va\\/.*': 'List Landing Page VA',
      '.*\\/vi\\/.*': 'List Landing Page VI',
      '.*\\/vm\\/.*': 'List Landing Page VM',
      '.*\\/vn\\/.*': 'List Landing Page VN',
      '.*\\/o\\/.*': 'Operator Page',
      '.*\\/t\\/.*': 'Tour Detail Page',
      '^/$|^\\/de\\/$|^\\/es\\/$|^\\/fr\\/$|^\\/nl\\/$': 'Homepage',
      '.*\\/book-now\\/.*': 'Book Now Page',
      '.*\\/booking\\/payment_success\\/.*': 'Booking Success Page',
      '.*\\/booking\\/.*': 'Booking Conversation Page',
      '.*\\/account\\/.*|.*\\/login\\/.*|.*\\/registration\\/.*': 'Account and Login Pages',
      '.*\\/wishlist\\/.*': 'Wishlist Page',
      '.*\\/search.*|.*\\/suche.*': 'Search Page (Basic)',
      '.*\\/srp\\/d-.*': 'Search Result Page D',
      '.*\\/srp\\/a-.*': 'Search Result Page A',
      '.*\\/srp\\/b-.*': 'Search Result Page B',
      '.*\\/srp\\/c-.*': 'Search Result Page C',
      '.*\\/srp\\/f-.*': 'Search Result Page F',
      '.*\\/srp\\/fa-.*': 'Search Result Page FA',
      '.*\\/srp\\/fj-.*': 'Search Result Page FJ',
      '.*\\/srp\\/i-.*': 'Search Result Page I',
      '.*\\/srp\\/il-.*': 'Search Result Page IL',
      '.*\\/srp\\/j-.*': 'Search Result Page J',
      '.*\\/srp\\/l-.*': 'Search Result Page L',
      '.*\\/srp\\/m-.*': 'Search Result Page M',
      '.*\\/srp\\/n-.*': 'Search Result Page N',
      '.*\\/srp\\/p-.*': 'Search Result Page P',
      '.*\\/srp\\/pa-.*': 'Search Result Page PA',
      '.*\\/srp\\/r-.*': 'Search Result Page R',
      '.*\\/srp\\/s-.*': 'Search Result Page S',
      '.*\\/srp\\/sc-.*': 'Search Result Page SC',
      '.*\\/srp\\/u-.*': 'Search Result Page U',
      '.*\\/srp\\/v-.*': 'Search Result Page V',
      '.*\\/srp\\/va-.*': 'Search Result Page VA',
      '.*\\/srp\\/vi-.*': 'Search Result Page VI',
      '.*\\/srp\\/vm-.*': 'Search Result Page VM',
      '.*\\/srp\\/vn-.*': 'Search Result Page VN',
      '.*\\/deals\\/.*|.*\\/angebote\\/.*|.*\\/ofertas\\/.*|.*\\/offres\\/.*': 'Deals Page',
    };

    const returnValue = Object.entries(patterns).find(([pattern]) => new RegExp(pattern).test(pagePath));

    return returnValue ? returnValue[1] : 'Other Pages';
  };

  const getParamPagePathEN = () => {
    const hrefLangLink = document.querySelector('link[rel="alternate"][hreflang="en"]');
    return hrefLangLink ? hrefLangLink.href : '';
  };

  const getParamUserLoginStatus = () => {
    if (dataLayerProperties.travellerId) {
      return 'Signed In';
    }

    if (getCookie('a_customer_id')) {
      return 'Recognized'; // AmplitudeCustomerId
    }

    return 'Anonymous';
  };

  const getParamUserType = () => {
    const { isInternalTraffic, host: pageHostname, b2b_method: B2BMethod } = dataLayerProperties;

    if (isInternalTraffic === 'yes') {
      return 'TourRadar Staff';
    }

    if (pageHostname.startsWith('travelagents') && !B2BMethod) {
      return 'Travel Agent';
    }

    if (B2BMethod === 'agent') {
      return 'Travel Agent';
    }

    if (B2BMethod === 'link') {
      return 'Travel Agent Client';
    }

    if (B2BMethod === 'whitelabel' || B2BMethod === 'affiliate') {
      return 'B2B Partner';
    }

    return 'Customer';
  };

  const getParamAmpStats = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('amp_stats_blocker');
  };

  const trackUserIdentity = () => {
    const userIdentifyProperties = {
      tr_account_id: dataLayerProperties.travellerId,
      user_login_status: getParamUserLoginStatus(),
      user_locale: getParamPageDomain(),
      user_nps_score: dataLayerProperties.nps_score,
      user_ces_score: dataLayerProperties.user_ces_score,
      b2b_type: dataLayerProperties.b2b_method,
      b2b_partner_id: dataLayerProperties.b2b_partner_id,
      browser_user_agent_string: navigator.userAgent,
      user_type: getParamUserType(),
      web_or_app: dataLayerProperties.datasource || 'web',
      amp_seo_psi_blocker: getParamAmpStats(),
    };

    const identifyEvent = new amplitude.Identify();
    Object.entries(userIdentifyProperties).forEach(([key, value]) => {
      identifyEvent.set(key, value);
    });

    amplitude.identify(identifyEvent);
  };

  const trackSERP = () => {
    const serpViewedProperties = {
      page_path: pagePath,
      page_full_url: window.location.href,
      page_domain: getParamPageDomain(),
      page_type: dataLayerProperties.contentType,
      page_type_detailed: getParamPageTypeDetailed(),
      travel_destination: dataLayerProperties.page_destination,
      page_path_en: getParamPagePathEN(),
      page_subdomain: dataLayerProperties.host,
      tour_id: dataLayerProperties.toursIDs,
      b2b_whitelabel_type: dataLayerProperties.b2b_whitelabel_type,
      b2b_type: dataLayerProperties.b2b_method,
      sponsored_content_id: dataLayerProperties.sponsoredTourIDs,
      web_or_app_event: dataLayerProperties.datasource || 'web',
      tour_discount_percentage: dataLayerProperties.tour_discount_percentage,
      page_previous_url: document.referrer,
      has_service_fee: dataLayerProperties.has_service_fee,
      service_fee: dataLayerProperties.service_fee,
    };

    amplitude.track('serp_viewed', serpViewedProperties);
  };

  const initiateAmplitudeUtils = () => {
    [dataLayerProperties] = window.dataLayer;
    amplitudeInitialization();
    pageType = $('main').data('page-type');
    if (pageType === 'SERP' || pageType === 'loc') {
      trackSERP();
    }
    trackUserIdentity();
  };

  initiateAmplitudeUtils();
};

export const tempRemoveDomainPrefixFromPath = (path) => {
  let newPath = path;
  if (newPath[0] !== '/') {
    newPath = `/${newPath}`;
  }

  const langPattern = /^\/(nl|ru|de|it|pt|fr|es|mx|cn)\//;
  return newPath.replace(langPattern, '/');
};

export const appendCurrentDomainPrefix = (path) => {
  const cleanPath = tempRemoveDomainPrefixFromPath(path);
  const domainPrefix = getDomainUrl();
  return (domainPrefix ? `/${domainPrefix}` : '') + String(cleanPath);
};

export const exposeTourRadarMembershipExperiment = () => {
  if (abTests && typeof abTests.exposure === 'function') {
    abTests.exposure('service-fee');
  }
};

export const exposeDepartureCardsExperiment = () => {
  if (abTests && typeof abTests.exposure === 'function') {
    abTests.exposure('tdp-departure-cards');
  }
};

export const exposeTDPNavigationExperiment = () => {
  if (abTests && typeof abTests.exposure === 'function') {
    abTests.exposure('tdp_navigation_menu_2');
  }
};

export const exposeHeaderPaxSelectorExperiment = () => {
  if (abTests && typeof abTests.exposure === 'function') {
    abTests.exposure('header_pax_selector');
  }
};

export const exposeStructuredItineraryExperiment = () => {
  if (abTests && typeof abTests.exposure === 'function') {
    abTests.exposure('structured_itinerary_3');
  }
};

export const isDownloadBrochureModalOpened = () => {
  const urlQueryString = new URLSearchParams(document.location.search);
  const isTDP = window.location.pathname.includes('/t/');
  return isTDP && (urlQueryString.has('pdf') || urlQueryString.has('open_download_brochure'));
};

export const getFormattedDateFromUrl = () => {
  const match = window.location.hash.match(/#when=([^&,]*)/);
  if (!match) return null;

  const [day, month, year] = match[1].split('/').map(Number);
  const date = new Date(year, month - 1, day);
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
};

export const getLocationHashParameters = () => {
  const { hash } = window.location;
  if (!hash) {
    return {};
  }

  const hashWithoutHashmark = hash.substring(1);
  const params = {};
  const pairs = hashWithoutHashmark.split(',');

  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    if (key && value !== undefined) {
      params[key] = value;
    }
  });

  return params;
};

export const initiateAppBanner = () => {
  function isAppBannerBlacklistedPage() {
    const currentPath = window.location.pathname;
    const blacklistedPaths = [
      '/book-now', // BNP
      '/reset-password',
      '/careers',
      '/agents',
      '/travel-planner',
    ];

    // Check exact paths
    return blacklistedPaths.some((path) => currentPath.includes(path));
  }

  if (isAppBannerBlacklistedPage()) return;

  import('@scout/components/app-banner').then((module) => {
    const AppBanner = module.default;
    AppBanner();
  });
};

export const generateAppLink = (uri) => {
  const firstVisitParams = JSON.parse(localStorage.getItem('amplitude-first-visit'));
  const customData = {
    ...firstVisitParams,
    original_url: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
  };

  const oldSearchParams = new URLSearchParams(firstVisitParams?.original_uri);
  const newSearchParams = new URLSearchParams(window.location.search);
  const searchParams = new URLSearchParams({
    ...Object.fromEntries(oldSearchParams),
    ...Object.fromEntries(newSearchParams),
  });

  delete customData.original_uri;
  searchParams.append('custom_data', JSON.stringify(customData));
  return `https://tourradar.app.link/${uri}?${searchParams.toString()}`;
};

export const initializeSignupAndSavePopup = () => {
  const showPopup = () => {
    import(/* webpackChunkName: "SignupPopup" */'app/application/views/pw/_common/scout/components/email-aquisition-popup/signup-and-save-popup').then((module) => {
      const SignupAndSavePopup = module.default;
      const popup = new SignupAndSavePopup();
      popup.initiate();
    });
  };

  byUserInteraction('initiate-social-popup', showPopup);
};

export const initializeTravelagentsLoginPrompt = () => {
  byUserInteraction('travelagents-login-prompt', () => {
    import(/* webpackChunkName: "TravelagentsLoginPrompt" */'./travelagents_login_prompt/script').then((module) => {
      const TravelagentsLoginPrompt = module.default;
      const travelagentsLoginPrompt = new TravelagentsLoginPrompt();
      travelagentsLoginPrompt.init();
    });
  });
};
